import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { HELP_DOCUMENT_API } from "./apiRoutes";

interface getProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getHelpDocumentById = async (id: string) =>
  await axiosAuth.get(`${HELP_DOCUMENT_API}/${id}`);

const useGetHelpDocumentById = ({
  id,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["help-documents", id],
    queryFn: () => getHelpDocumentById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetHelpDocumentById;
